import { Undo } from "@mui/icons-material";
import { Box, Button, useTheme } from "@mui/material";
import { CacheKeyTypes, invalidateKeysByType } from "@services/cache";
import queryClient from "@services/query-client";
import trpcClient from "@services/rpc-client";
import { captureAndDisplayError } from "@src/utils";
import React from "react";

export interface UndoPromptContentProps {
  message: string;
  undo_id: string;
  affected_keys?: CacheKeyTypes[];
}

export const UndoPromptContent: React.FC<UndoPromptContentProps> = ({ message, undo_id, affected_keys }) => {
  const theme = useTheme();

  const onClickUndo = async () => {
    try {
      await trpcClient.mutation("operation/undo", { undo_id });
      if (affected_keys) {
        invalidateKeysByType(affected_keys);
      } else {
        queryClient.invalidateQueries();
      }
    } catch (error) {
      captureAndDisplayError(error as Error);
    }
  };

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      p={1}
      width={"100%"}
      bgcolor={theme.palette.background.paper}
      border={0.5}
      borderColor={(t) => t.palette.grey[700]}
      borderRadius={1}
      // borderRadius={theme.shape.borderRadius}
    >
      <Box flex={1}>{message}</Box>
      <Button size={"small"} onClick={onClickUndo} variant="outlined" startIcon={<Undo />}>
        Undo
      </Button>
    </Box>
  );
};

export default UndoPromptContent;
